/**
 * Core: Bugsnag
 * -----------------------------------------------------------------------------
 * Setup Bugsnag error monitoring.
 * - Only runs if process.env.BUGSNAG_API_KEY variable exists, this is setup in
 *   Buddy so Bugsnag only runs after a proper deployment.
 *
 */
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

export default () => {

  /**
   * Make Bugsnag variable globally available.
   */
  window.Bugsnag = Bugsnag

  /**
   * Create globally available error reporting function.
   * @param {String} message - Console error message.
   * @param {*} error - Error variable for Bugsnag.
   */
  window.reportError = (message, error) => {
    if (cnvs.environment.bugsnagApiKey !== 'BUGSNAG_API_KEY') {
      Bugsnag.notify(error)
    }

    /**
     * If non-production theme then log error to console otherwise useful error
     * is swallowed when inside a try...catch.
     * - https://we-make-websites.atlassian.net/browse/CANVAS-125
     */
    if (
      cnvs.theme.name && !cnvs.theme.name.toLowerCase().includes('production') ||
      cnvs.theme.role && cnvs.theme.role !== 'main'
    ) {
      window.console.log(message, error)
    }

    throw new Error(message, error)
  }

  /**
   * Initialise Bugsnag.
   */
  function init() {
    if (cnvs.environment.bugsnagApiKey === 'BUGSNAG_API_KEY') {
      return
    }

    Bugsnag.start({
      apiKey: cnvs.environment.bugsnagApiKey,
      appVersion: cnvs.environment.release,
      plugins: [new BugsnagPluginVue()],
    })
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
